// extracted by mini-css-extract-plugin
module.exports = {"v1q7fu7f":"v1q7fu7f","c1x5qlc5":"c1x5qlc5"};